import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { 
  Shield, 
  ArrowLeft,
  FileText,
  Scale,
  AlertTriangle,
  Clock,
  CheckCircle,
  XCircle,
  Info,
  Phone,
  Mail
} from 'lucide-react';

const GarantiSartlari = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative py-16 md:py-24 bg-gradient-to-br from-[#006D77] via-[#0A9396] to-[#006D77] overflow-hidden">
        <div className="absolute top-0 left-0 w-64 h-64 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/5 rounded-full translate-x-1/3 translate-y-1/3"></div>
        
        <div className="max-w-4xl mx-auto px-4 relative z-10">
          <div className="text-center">
            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm border border-white/30 rounded-full px-5 py-2.5 mb-6">
              <Scale className="w-5 h-5 text-white" />
              <span className="text-white font-semibold">Yasal Şartlar</span>
            </div>
            
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-4">
              HizmetGeliyo Garantisi
              <span className="block text-[#F6AD55] mt-2">Şart ve Koşulları</span>
            </h1>
            
            <p className="text-white/80 text-lg max-w-2xl mx-auto">
              Son güncelleme: Aralık 2025
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-20">
        <div className="max-w-4xl mx-auto px-4">
          {/* Back Button */}
          <Button
            variant="outline"
            onClick={() => navigate('/garanti')}
            className="mb-8 border-[#006D77] text-[#006D77] hover:bg-[#006D77] hover:text-white"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Garanti Sayfasına Dön
          </Button>

          {/* Terms Content */}
          <div className="bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden">
            {/* Section 1: Giriş */}
            <div className="p-8 border-b border-gray-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-[#006D77] to-[#0A9396] rounded-xl flex items-center justify-center">
                  <FileText className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">1. GİRİŞ</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  <strong>1.1.</strong> İşbu garanti koşulları ve Web Sitesinde yer alan diğer kurallar, 
                  HizmetGeliyo tarafından sunulan platforma kayıtlı Hizmet Veren'lerden (ustalardan) alınan 
                  hizmetlere ilişkin garanti kurallarını düzenlemektedir.
                </p>
                
                <div className="bg-gray-50 rounded-xl p-5 space-y-3">
                  <p className="font-semibold text-gray-900">1.2. Tanımlar:</p>
                  <ul className="space-y-2 ml-4">
                    <li><strong>"HizmetGeliyo"</strong>: HizmetGeliyo platformunu işleten şirketi ifade eder.</li>
                    <li><strong>"Web Sitesi"</strong>: hizmetgeliyo.com internet sitesini ifade eder.</li>
                    <li><strong>"Kullanıcı"</strong>: Herhangi bir sebeple Web Sitesi'ni kullanan kişileri ifade eder.</li>
                    <li><strong>"Hizmet Alan"</strong>: Web Sitesi üzerinden Hizmet Talebi gönderen gerçek veya tüzel kişi Kullanıcı'yı ifade eder.</li>
                    <li><strong>"Hizmet Veren (Usta)"</strong>: Hizmet sağlamak üzere Web Sitesi üzerinden kayıtlı ve onaylanmış profesyonel hizmet sağlayıcıyı ifade eder.</li>
                    <li><strong>"Hizmet Talebi"</strong>: Hizmet Alan tarafından, bir veya daha fazla Hizmet Veren'den teklif almak amacıyla Web Sitesi üzerinde yayınlanan talebi ifade eder.</li>
                    <li><strong>"Anlaşmaya Varılmış İş"</strong>: Hizmet Veren tarafından gönderilen teklifin Hizmet Alan tarafından kabul edilmesi sonucu oluşan anlaşmayı ifade eder.</li>
                  </ul>
                </div>

                <p>
                  <strong>1.3.</strong> Kullanıcının, Web Sitesi üzerinden Hizmet Talebini onaylaması, işbu şartları 
                  onayladığı veya Web Sitesinden yararlanmaya başladığı andan itibaren işbu şartlara uymayı 
                  taahhüt ettiği kabul edilir.
                </p>

                <p>
                  <strong>1.4.</strong> HizmetGeliyo, aracılık hizmetlerinin sürekliliğini sağlama, ileride doğacak 
                  teknik zaruretler veya mevzuata uyum sağlanması amacıyla işbu koşulları, Kullanıcılar aleyhine 
                  olmamak kaydıyla tek taraflı olarak değiştirme ya da tadil etme hakkına sahiptir.
                </p>

                <p>
                  <strong>1.5.</strong> HizmetGeliyo, herhangi bir değişiklik olması halinde güncel garanti şartlarını 
                  aynı link altında yeni tarih güncellemesi ile Web Sitesi'nde yayınlayacaktır.
                </p>
              </div>
            </div>

            {/* Section 2: Garanti Tanımı */}
            <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-green-50/50 to-transparent">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl flex items-center justify-center">
                  <Shield className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">2. GARANTİ TANIMI</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  <strong>2.1.</strong> Kullanıcılar tarafından HizmetGeliyo üzerinden teklifini seçerek anlaşma yapılan 
                  Hizmet Veren'lerin, taahhüt ettiği hizmeti (Anlaşmaya Varılmış İş) sağlarken, Hizmet Alan'lara 
                  karşı doğrudan sebep olduğu zararların karşılanması amacıyla işbu garanti koşulları oluşturulmuştur.
                </p>

                <div className="bg-green-50 border border-green-200 rounded-xl p-5">
                  <div className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                    <p>
                      <strong>2.2.</strong> İşbu garanti koşullarının kapsamı; zarar gören mal ve mülklerinizin tamir 
                      edilmesi veya yerine yenisinin alınması gereken haller ile talep sahibinin ya da 3. kişilerin 
                      fiziksel yaralanması veya sakatlık sebebiyle doğan sağlık giderlerinin karşılanması kapsamı ile sınırlıdır.
                    </p>
                  </div>
                </div>

                <p>
                  <strong>2.3.</strong> Aşağıda belirtilmiş olan koşullara tabi olmak üzere Hizmet Veren'in tüm hizmet 
                  uygulamaları HizmetGeliyo'nun garantisi altındadır.
                </p>

                <div className="bg-amber-50 border border-amber-200 rounded-xl p-5">
                  <div className="flex items-start gap-3">
                    <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
                    <p>
                      <strong>2.4.</strong> İşbu garanti koşullarının ilan edilmesinden önce yapılan uygulamalar, 
                      HizmetGeliyo platformunda kayıtlı Hizmet Veren'lerin platform dışında vermiş olduğu hizmetler 
                      ve garanti sözleşmesinde yer alan koşullar dışında yapılan uygulamalar garanti kapsamında değildir.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 3: Garanti Süresi */}
            <div className="p-8 border-b border-gray-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center">
                  <Clock className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">3. GARANTİ SÜRESİ</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-blue-50 border border-blue-200 rounded-xl p-5">
                    <div className="text-3xl font-bold text-blue-600 mb-2">30 Gün</div>
                    <p className="text-sm">
                      <strong>3.1.</strong> Hizmet Veren'den alınan hizmet başlamadan evvel ve talep tarihinden itibaren 
                      en geç 30 gün içinde beğenilen teklifin HizmetGeliyo üzerinden seçilmiş olması gerekir.
                    </p>
                  </div>
                  
                  <div className="bg-purple-50 border border-purple-200 rounded-xl p-5">
                    <div className="text-3xl font-bold text-purple-600 mb-2">6 Ay</div>
                    <p className="text-sm">
                      <strong>3.2.</strong> Garanti kapsamında tazmini talep edilecek zararın, Anlaşmaya Varılmış İş'in 
                      başladığı tarihten itibaren 6 ay içinde gerçekleşmiş olması gerekir.
                    </p>
                  </div>
                </div>

                <div className="bg-red-50 border border-red-200 rounded-xl p-5">
                  <div className="flex items-start gap-3">
                    <AlertTriangle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
                    <div>
                      <p className="font-semibold text-red-800 mb-2">Önemli: 72 Saat Kuralı</p>
                      <p className="text-red-700 text-sm">
                        Zarar gerçekleştikten sonra en geç <strong>72 saat</strong> içinde HizmetGeliyo'ya yazılı olarak 
                        durumun bildirilmiş olması gerekir. Hizmet Veren ile Hizmet Alan iletişim içinde olmuş olsa dahi, 
                        72 saat içinde HizmetGeliyo'ya haber edilmeyen zararlar tazmin kapsamı dışında kalacaktır.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 4: Başvuru Süreci */}
            <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-indigo-50/50 to-transparent">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center">
                  <FileText className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">4. BAŞVURU SÜRECİ</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  <strong>4.1.</strong> Garanti tazmininden faydalanma talebi olan Hizmet Alan kullanıcıların, 
                  <a href="/garanti" className="text-[#006D77] hover:underline font-medium"> Garanti Bilgi Formunu</a> doldurması yeterlidir. 
                  Form, HizmetGeliyo yetkililerine ulaştıktan itibaren en geç <strong>48 saat</strong> sonra Garanti ekibi, 
                  talep eden kullanıcı ile iletişime geçecektir.
                </p>

                <div className="bg-indigo-50 border border-indigo-200 rounded-xl p-5">
                  <p>
                    <strong>4.2.</strong> Formun gönderildiği tarihten itibaren en geç <strong>1 ay</strong> içinde, 
                    söz konusu talebin inceleme süreci sonlandırılmaya çalışılacaktır. Bu süreç, zararın boyutu, 
                    kullanıcı ve hizmet veren kişiler ile olan iletişim süreci, bu iletişimdeki hız ve kullanıcının 
                    paylaştığı zarara dair dokümantasyona bağlı olarak değişebilir.
                  </p>
                </div>
              </div>
            </div>

            {/* Section 5: Faydalanma Koşulları */}
            <div className="p-8 border-b border-gray-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-xl flex items-center justify-center">
                  <CheckCircle className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">5. GARANTİDEN FAYDALANMA KOŞULLARI</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  <strong>5.1.</strong> Hizmet Alan ve zarar gören kullanıcı, öncelikle işbu şartnamedeki hizmet almış 
                  olma süre ve şartlarına, başvuru sürelerine ve şekline uygun davranmış olmalıdır.
                </p>

                <p>
                  <strong>5.2.</strong> Garanti hizmetinden faydalanmak için, Hizmet Alan'ın HizmetGeliyo'da 
                  kullanıcı hesabının olması gerekmektedir.
                </p>

                <p>
                  <strong>5.3.</strong> Zarar tazmin talebindeki talep içeriğinde, Hizmet Alan kullanıcı, kabul ettiği 
                  teklifin (Anlaşmaya Varılmış İş) detayları ve ücretini belirtmeli; ücret ve randevu tarihi değişikliğe 
                  uğramış ise iş başlamadan önce HizmetGeliyo'da bu bilgileri yenilemiş olmalıdır.
                </p>

                <p>
                  <strong>5.4.</strong> Zarar tazmin talebinde bulunmadan evvel, telafi talebinin öncelikle Hizmet 
                  Veren'e yöneltilmiş olması ve Hizmet Veren ile bu konuda yapılan iletişim sürecinde Hizmet Alan 
                  kullanıcı, elinden geldiğince çabalamış olmalıdır.
                </p>

                <div className="bg-amber-50 border border-amber-200 rounded-xl p-5">
                  <p>
                    <strong>5.5.</strong> Hizmet Alan'ın uğramış olduğu zarar, aynı zamanda Türk Ceza Kanunu ve diğer 
                    özel ceza kanunlarına göre Suç teşkil eden bir eylemden doğmuş ise, bu konuda kolluk kuvvetlerine / 
                    savcılıklara suç duyurusunda bulunmuş olunmalı, olay yeri inceleme tutanağı, şikayet dilekçesi, 
                    ifade tutanağı gibi belgelerin ilgililerin ve memurların onayını içeren şekilde nüshalarının 
                    HizmetGeliyo ile paylaşılıyor olması gerekir.
                  </p>
                </div>

                <p>
                  <strong>5.6.</strong> Zarar tazmini talep eden Hizmet Alan'ın, zarar gören malın sahibi veya ilgili 
                  kişinin temsilcisi olduğunu kanıtlayan, ayrıca malın değerini ve zararı kanıtlayan belgelerin 
                  (fatura, fotoğraf, video gibi kayıtlar) HizmetGeliyo ile paylaşılması gerekir.
                </p>

                <p>
                  <strong>5.7.</strong> Tazmini talep edilen zararın tespiti veya incelenebilmesi için HizmetGeliyo, 
                  ilgili Hizmet Alan için kendi çalışanı bir uzmanı veya görevlendirdiği bir uzmanı yönlendirebilir. 
                  Hizmet Alan kullanıcının böyle bir incelemeye izin vermiş olması gerekir.
                </p>

                <p>
                  <strong>5.8.</strong> Eğer Hizmet Veren tarafından hizmetin ifası sırasında verilmiş bir bedeni zarar 
                  varsa ve bu bedeni zarar medikal giderlere sebebiyet vermiş ise, ilgili bedeni zararın tedavisine dair 
                  doktor raporları, medikal görüntüleme, laboratuvar, acil servis, ilaç ve hastane faturalarının 
                  HizmetGeliyo ile paylaşılması gerekir.
                </p>

                <p>
                  <strong>5.9.</strong> HizmetGeliyo'nun talebi halinde maddi veya bedeni zarar gören Hizmet Alan, 
                  söz konusu zararlarla ilgili Hizmet Veren'e dava açmalı ve/veya suç duyurusunda bulunmalı; dava 
                  ve/veya suç duyurusu dilekçesini HizmetGeliyo ile paylaşmış olmalıdır.
                </p>

                <p>
                  <strong>5.10.</strong> HizmetGeliyo garanti ödemesi yapmayı uygun gördüğü takdirde, bu talepte 
                  bulunan Hizmet Alan kullanıcının HizmetGeliyo ile Ödeme ve İbra Anlaşması imzalaması gerekir.
                </p>
              </div>
            </div>

            {/* Section 6: Kapsam Dışı */}
            <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-red-50/50 to-transparent">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-red-500 to-rose-600 rounded-xl flex items-center justify-center">
                  <XCircle className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">6. GARANTİ KAPSAMI DIŞINDA KALAN DURUMLAR</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  <strong>6.1.</strong> 6502 sayılı Tüketicin Korunması Hakkında Kanun'un 8. Maddesinde tanımlanan 
                  Ayıplı Mal'lar ve 13. Maddesinde tanımlanan Ayıplı Hizmet'ler işbu garantinin kapsamı dışındadır. 
                  Bu konulardaki talepler için doğrudan Hizmet Veren'e ve/veya Hakem Heyetlerine ya da Tüketici 
                  Mahkemelerine başvurulmalıdır.
                </p>

                <div className="bg-red-50 border border-red-200 rounded-xl p-5">
                  <p className="font-semibold text-red-800 mb-3">6.2. Garanti kapsamı dışında olan mal/mülk/ürünler:</p>
                  <ul className="space-y-2 text-red-700 text-sm ml-4">
                    <li>• Otomobil, ulaşım taşıtları, su araçları, hava araçları</li>
                    <li>• Para, döviz, değerli madenler, hisse ve borç senetleri</li>
                    <li>• Ev hayvanları ve bitkileri</li>
                    <li>• Transit (taşıma esnasında) mal/mülkler</li>
                    <li>• Güzel sanat eserleri, antika eşyalar, koleksiyon ürünleri</li>
                    <li>• Elektronik data, yazılımlar, bilgi işlem cihazları</li>
                  </ul>
                </div>

                <div className="bg-red-50 border border-red-200 rounded-xl p-5">
                  <p className="font-semibold text-red-800 mb-3">6.3. Garanti kapsamı dışında olan zararlar:</p>
                  <ul className="space-y-2 text-red-700 text-sm ml-4">
                    <li>• Sitedeki talep formunda belirtilmemiş işler ve ek işler</li>
                    <li>• Fiziksel olmayan, duygusal veya mental zararlardan doğan giderler</li>
                    <li>• Yapılan işin parçası kabul edilecek nitelikte doğal ve normal zararlar</li>
                    <li>• Deprem, sel, heyelan gibi doğal afetler sebebiyle gerçekleşen zararlar</li>
                    <li>• Doğrudan Hizmet Veren'in kusuru olmayan zararlar</li>
                    <li>• Zarardan dolayı mahrum kalınan muhtemel kazanç</li>
                    <li>• Manevi değeri olan (aileden kalma) eşyaların tazmini</li>
                    <li>• İşin geç bitirilmesinden kaynaklanan zararlar</li>
                    <li>• Hırsızlık ya da kötü niyetli davranışlar</li>
                    <li>• Savaş, terör ve halk hareketleri nedenli zararlar</li>
                    <li>• Elektrik, su, doğal gaz servislerinin kesilmesinden doğan zararlar</li>
                    <li>• Nem, küf, mantar veya böcek zararları</li>
                    <li>• Nakliye sürecinde paketleme hatası (Hizmet Veren yapmadıysa)</li>
                    <li>• Temizlik sürecinde elektronik eşyaların taşınmasından doğan zararlar</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Section 7: Tazminatlar */}
            <div className="p-8 border-b border-gray-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-orange-600 rounded-xl flex items-center justify-center">
                  <Scale className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">7. TAZMİNATLAR</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-amber-50 border border-amber-200 rounded-xl p-5 text-center">
                    <div className="text-3xl font-bold text-amber-600 mb-2">₺5.000</div>
                    <p className="text-sm text-amber-700">
                      <strong>7.1.</strong> Mal/mülk/ürün zararlarında maksimum tazminat limiti
                    </p>
                  </div>
                  
                  <div className="bg-orange-50 border border-orange-200 rounded-xl p-5 text-center">
                    <div className="text-3xl font-bold text-orange-600 mb-2">₺5.000</div>
                    <p className="text-sm text-orange-700">
                      Medikal zararlar (illiyet bağı olan 3. kişiler dahil) için maksimum limit
                    </p>
                  </div>
                </div>

                <p>
                  <strong>7.2.</strong> HizmetGeliyo tarafından Garanti kapsamında tazmin edilmesine karar verilmiş ise, 
                  zararın tamiri, yenisinin alınması ya da iş değeri hususlarından <strong>en düşük bedelli olan</strong> tazmin edilecektir.
                </p>

                <p>
                  <strong>7.3.</strong> Zarara uğrayan Hizmet Alan, zararının bir kısmını diğer kaynaklardan (hizmet 
                  veren, malzeme üreticisi, diğer sigortalar vb.) karşılatmış ise veya bunun garantisi taahhüt edilmiş 
                  ise, alınan kısmi ödeme, HizmetGeliyo'nun tazmin edeceği tutardan düşülür.
                </p>

                <p>
                  <strong>7.4.</strong> Ödenecek tazminat bedeline karar verme konusunda tek yetkili HizmetGeliyo'dur. 
                  HizmetGeliyo, tazmin ödemesini nakdi olarak yapmak yerine aynı veya farklı bir Hizmet Veren'i ilgili 
                  işi tamamlamak için görevlendirme hakkını saklı tutar.
                </p>
              </div>
            </div>

            {/* Section 8: Diğer Garantiler */}
            <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-gray-50 to-transparent">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-gray-500 to-slate-600 rounded-xl flex items-center justify-center">
                  <Info className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">8. DİĞER GARANTİ VE SİGORTALAR</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <div className="bg-gray-100 border border-gray-200 rounded-xl p-5">
                  <p>
                    <strong>8.1.</strong> HizmetGeliyo'nun garantisi, herhangi bir sigorta niteliği veya taahhüdü 
                    içermez. Talep sahibi Hizmet Alan ya da 3. kişiler, bu kapsamda sigortalı sayılmazlar. 
                    HizmetGeliyo'nun sunmuş olduğu garanti, ev sahibi ya da kiracısı sigortasının, profesyonel, 
                    sağlık ya da diğer gerekli araç, can, mal/mülk konu alan sigortaların ve 3. kişi mali 
                    sorumluluk sigortalarının yerine geçmez.
                  </p>
                </div>

                <p>
                  <strong>8.2.</strong> HizmetGeliyo tarafından sunulan garanti yeterli görülmediği veya ek korumanın 
                  gerekli olduğu alanlarda, Hizmet Alan dilediği sigortaları yaptırmak ya da Hizmet Veren'den ek 
                  teminatlar isteme serbestisine sahiptir.
                </p>
              </div>
            </div>

            {/* Section 9: Rücu Hakkı */}
            <div className="p-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-violet-500 to-purple-600 rounded-xl flex items-center justify-center">
                  <Scale className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">9. HİZMETGELİYO'NUN RÜCU HAKKI VE ÖDEME ANLAŞMASI</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  <strong>9.1.</strong> HizmetGeliyo, incelemeleri sonucunda Hizmet Alan'a garanti ödemesi yapma 
                  kararı aldığı takdirde, ödeme yapılmadan önce Hizmet Alan bu anlaşmayı imzalamış olmalıdır. 
                  Bu ödeme anlaşması aşağıdaki hususlarda düzenlemeler içerir:
                </p>

                <ul className="space-y-3 ml-4">
                  <li>
                    <strong>9.1.1.</strong> HizmetGeliyo'nun zarar veren Hizmet Veren'e, söz konusu yaptığı tazminat 
                    ödemesini geri alabilmek için dava açabilme ve zarar gören Hizmet Alan'ın açtığı davaya müdahil 
                    olma hakkı.
                  </li>
                  <li>
                    <strong>9.1.2.</strong> HizmetGeliyo'nun açtığı bir dava var ise, zarar gören Hizmet Alan'ın, 
                    HizmetGeliyo'nun yanında ve gerektiğinde tanık olarak yer alma ve yardımcı olma yükümlülüğü.
                  </li>
                  <li>
                    <strong>9.1.3.</strong> Zarar gören Hizmet Alan'ın, tazminata konu zararıyla ilgili HizmetGeliyo'dan 
                    ileride herhangi bir beklentisi olmadığı beyanı.
                  </li>
                  <li>
                    <strong>9.1.4.</strong> Zarar gören Hizmet Alan'ın, HizmetGeliyo ile olan tüm iletişimini ve 
                    anlaşmalarını gizli tutacağı, üçüncü kişiler ile paylaşmayacağı ve sosyal medya dahil hiçbir 
                    mecrada bu hususta beyanda bulunmayacağı beyanı.
                  </li>
                  <li>
                    <strong>9.1.5.</strong> Zarar sebebiyle kendisine tazminat ödemesi yapılmış olan Hizmet Alan'ın, 
                    yanlış inceleme sonrası veya hatalı yapılmış tüm ödemelerin sebepsiz zenginleşme teşkil edeceğini 
                    bildiği ve bu durumda söz konusu tazmin bedelini HizmetGeliyo'ya ilk yazılı talebinde nakden ve 
                    peşin olarak iade edeceği kabul beyanı.
                  </li>
                </ul>

                <p>
                  <strong>9.2.</strong> Zarar tazmini ödemeleri, yalnızca HizmetGeliyo sitesinde profil sahibi olup 
                  da zarar görmüş olan Hizmet Alan'ın şahsi banka hesabına yapılır.
                </p>

                <p>
                  <strong>9.3.</strong> HizmetGeliyo her zaman ve her koşulda, Hizmet Alan'a veya Hizmet Veren'e 
                  gerekli gördüğü durumlarda rücu ve sebepsiz zenginleşme davaları açmaya yetkilidir.
                </p>
              </div>
            </div>
          </div>

          {/* Contact Box */}
          <div className="mt-12 bg-gradient-to-br from-[#006D77] to-[#0A9396] rounded-3xl p-8 text-white">
            <div className="text-center mb-6">
              <h3 className="text-2xl font-bold mb-2">Sorularınız mı var?</h3>
              <p className="text-white/80">
                Garanti koşulları hakkında daha fazla bilgi almak için bizimle iletişime geçin.
              </p>
            </div>
            
            <div className="grid md:grid-cols-2 gap-4">
              <a 
                href="tel:08502427808"
                className="flex items-center justify-center gap-3 bg-white/20 hover:bg-white/30 rounded-xl p-4 transition-colors"
              >
                <Phone className="w-5 h-5" />
                <span className="font-semibold">0850 242 78 08</span>
              </a>
              <a 
                href="mailto:destek@hizmetgeliyo.com"
                className="flex items-center justify-center gap-3 bg-white/20 hover:bg-white/30 rounded-xl p-4 transition-colors"
              >
                <Mail className="w-5 h-5" />
                <span className="font-semibold">destek@hizmetgeliyo.com</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default GarantiSartlari;
